export enum CompanyPeer {
  SUGAR_CUSTOMER_STATUS = 'Customer',
  SUGAR_ONBOARDING_STATUS = 'Onboarding',
}
